var AccessRestricted = function AccessRestricted() {
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-not-found"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-not-found__title"
  }, "Access Restricted"), /*#__PURE__*/React.createElement("div", {
    className: "page-not-found__description"
  }, "You do not have access to view this page."))));
};
export default AccessRestricted;